import Vue from "vue"
import { showGlobalMessage, getDeliveryMethod } from "@/utils/utils"

export const MAX_VALUE = 99

export const isChecked = (item = {}) => {
  return item.checked === 1
}
export const soldOut = (item = {}) => {
  return item.wareStatus && item.wareStatus.invalidWareFlag === 1
}
// 自提模式 && abnormalState === 4
export const deliveryOnly = (item = {}) => {
  // return getDeliveryMethod() === "clickCollect" && item.wareStatus && item.wareStatus.abnormalState === 4
  return false
}
export const noPickupTime = (item = {}) => {
  return item.wareStatus && item.wareStatus.invalidWareFlag === 1 && item.wareStatus.abnormalState === 5
}
export const getMax = (item = {}) => {
  if (!item.remainingStock) return MAX_VALUE
  if (item?.wareStatus?.maxCount) {
    return item.wareStatus.maxCount
  }

  if (item.remainingStock > MAX_VALUE) {
    return MAX_VALUE
  }
  return item.remainingStock
}
export const fen2Yuan = num => {
  if (isNaN(num)) return ""
  num = Number(num)
  return (num / 100).toFixed(2)
}
export const getNumber = nums => {
  const num = fen2Yuan(nums)
  const str = num.toString()
  const res = str.split(".")
  return res[0]
}
export const getSmallNumber = nums => {
  const num = fen2Yuan(nums)
  const str = num.toString()
  const res = str.split(".")
  return res.length === 2 ? res[1] : ""
}

export const showMessage = (message = "", subMessage = "") => {
  Vue.nextTick(() => {
    const headerEl = document.getElementById("top-box")
    const headerHeight = (headerEl && headerEl.clientHeight) || 0
    const gap = 16
    showGlobalMessage({
      message,
      subMessage,
      gap: headerHeight + gap,
      iconClass: "messageWarning"
    })
  })
}

// 对后端数据进行自提和配送数据格式化处理
function distributePreOrderShipmentType(data) {
  // 深拷贝数据以避免修改原始对象
  const result = JSON.parse(JSON.stringify(data))
  // 获取根级别的 preOrderShipmentType 值
  const preOrderShipmentType = result.preOrderShipmentType
  // 获取根级别的 offlinePaymentFlag 值为null/0
  const offlinePaymentFlagType = result.offlinePaymentFlag || 0
  // 如果没有 itemGroupList 或者它不是数组，直接返回
  if (!result.itemGroupList || !Array.isArray(result.itemGroupList)) {
    return result
  }
  // 遍历 itemGroupList
  result.itemGroupList.forEach(itemGroup => {
    // 添加到 itemGroup 级别
    itemGroup.preOrderShipmentType = preOrderShipmentType
    // 确保每个 item 也有offlinePaymentFlagType为null/0 就是原有的格式
    itemGroup.offlinePaymentFlagType = offlinePaymentFlagType
    // 如果 itemGroup 有 itemList，遍历其中的每个 item
    if (itemGroup.itemList && Array.isArray(itemGroup.itemList)) {
      itemGroup.itemList.forEach(item => {
        // 确保每个 item 也有 preOrderShipmentType
        item.preOrderShipmentType = preOrderShipmentType
        // 确保每个 item 也有offlinePaymentFlagType为null/0 就是原有的格式
        item.offlinePaymentFlagType = offlinePaymentFlagType
        // 如果 item 有 wareList，遍历其中的每个 ware
        if (item.wareList && Array.isArray(item.wareList)) {
          item.wareList.forEach(ware => {
            // 确保每个 ware 也有 preOrderShipmentType
            ware.preOrderShipmentType = preOrderShipmentType
            ware.offlinePaymentFlagType = offlinePaymentFlagType
          })
        }
      })
    }
  })
  return result
}

// 最最后一层的数据合并到itemList
// function mergeItemGroupsByType(data) {
//   const itemGroupList = data.itemGroupList
//   const mergedGroups = {}
//   // 遍历 itemGroupList，按 itemGroupType 分组
//   itemGroupList.forEach(itemGroup => {
//     const itemGroupType = itemGroup.itemGroupType
//     if (!mergedGroups[itemGroupType]) {
//       mergedGroups[itemGroupType] = {
//         itemGroupType,
//         itemGroupName: itemGroup.itemGroupName,
//         itemList: [],
//         preOrderShipmentType: itemGroup.preOrderShipmentType
//       }
//     }
//     // 合并 itemList
//     mergedGroups[itemGroupType].itemList = mergedGroups[itemGroupType].itemList.concat(itemGroup.itemList)
//   })
//   // 将合并后的分组转换为数组
//   const mergedItemGroupList = Object.values(mergedGroups)
//   // 更新原始数据中的 itemGroupList
//   data.itemGroupList = mergedItemGroupList

//   return data
// }
// 这里的item 没有唯一标识，但需要深度比较（因为性能较差），使用 JSON.stringify 或 Map
function mergeItemGroupsByType(data) {
  const itemGroupList = data.itemGroupList || []
  const mergedGroups = {}

  itemGroupList.forEach(itemGroup => {
    const itemGroupType = itemGroup.itemGroupType
    if (!mergedGroups[itemGroupType]) {
      mergedGroups[itemGroupType] = {
        itemGroupType,
        itemGroupName: itemGroup.itemGroupName,
        itemList: [],
        preOrderShipmentType: itemGroup.preOrderShipmentType
      }
    }

    // 使用 Map 去重（基于 JSON.stringify）
    const itemMap = new Map()
    mergedGroups[itemGroupType].itemList.forEach(item => {
      itemMap.set(JSON.stringify(item), item)
    })
    itemGroup.itemList?.forEach(newItem => {
      itemMap.set(JSON.stringify(newItem), newItem)
    })

    mergedGroups[itemGroupType].itemList = Array.from(itemMap.values())
  })

  data.itemGroupList = Object.values(mergedGroups)
  return data
}
// 获取围栏内主门店
export const getRangeStore = data => {
  if (data.storeGroupList?.length && !data.storeGroupList[0]?.storeList[0]) {
    return {}
  }
  // 围栏内数据(storeGroupType === 'Range') 才会在购物车显示，UnRange是不会显示的
  const rangeStoreGroup = (data.storeGroupList || []).find(item => item.storeGroupType === "Range") || {}
  // 原来的逻辑是只有一个门店，现在增加配送之后，有多个门店，且后端数据返回的storeList长度可能为2，需要修改逻辑如下
  let firstStore = []
  if (rangeStoreGroup.storeList && rangeStoreGroup.storeList.length === 1) {
    // 自提
    firstStore = distributePreOrderShipmentType(rangeStoreGroup.storeList[0])
  } else if (rangeStoreGroup.storeList && rangeStoreGroup.storeList.length > 1) {
    // 配送
    // 深拷贝第一个 itemGroup，避免污染原始数据
    firstStore = structuredClone(distributePreOrderShipmentType(rangeStoreGroup.storeList[0]))
    if (!firstStore.itemGroupList) {
      firstStore.itemGroupList = []
    }
    for (let i = 1; i < rangeStoreGroup.storeList.length; i++) {
      const currentStore = distributePreOrderShipmentType(rangeStoreGroup.storeList[i])
      if (currentStore?.itemGroupList) {
        // 进行itemList扁平化处理，与原逻辑匹配
        firstStore.itemGroupList.push(...currentStore.itemGroupList)
      }
    }
  }
  // 合并数据到itemList
  const mergeItemGroupsList = mergeItemGroupsByType(firstStore)
  const store = mergeItemGroupsList || {}
  return store
}

// 获取围栏内从门店列表
export const getRangeSlaveStoreList = data => {
  // 围栏内数据(storeGroupType === 'Range')
  const rangeStoreGroup = (data.storeGroupList || []).find(item => item.storeGroupType === "Range") || {}
  const slaveStoreList = rangeStoreGroup.otherStoreList || []
  return slaveStoreList
}

export const getItemGroup = (type, store = {}) => {
  const itemGroupList = store.itemGroupList || []

  return itemGroupList.find(item => item.itemGroupType === type) || {}
}

export const getWareItems = (type, store) => {
  const result = getItemGroup(type, store)
  return result.itemList || []
}

/**
 * 履约方式过滤（带特殊规则 + 默认兜底）
 * @param {Array} list 原始数据
 * @param {Number} selectedDeliveryId 当前选中的 deliveryId（1~4）
 * @param {Number} deliveryType 默认履约类型（1/2）
 */
export const filterShipmentList = (list, selectedDeliveryId, deliveryType) => {
  const strategyMap = {
    3: { preOrderShipmentType: 1, offlinePaymentFlagType: 1 },
    4: { preOrderShipmentType: 2, offlinePaymentFlagType: 1 }
  }

  const safeList = Array.isArray(list) ? list : []
  const rule = strategyMap[selectedDeliveryId]
  const OFFLINE_PAYMENT_FLAG = 1 // 线下支付专用标识

  // selectedDeliveryId = 3 / 4：走特殊规则
  if (rule) {
    return safeList.filter(
      item =>
        item.preOrderShipmentType === rule.preOrderShipmentType &&
        item.offlinePaymentFlagType === rule.offlinePaymentFlagType
    )
  }

  // 1/2：默认规则 + 排除线下支付数据
  return safeList.filter(
    item => item.preOrderShipmentType === deliveryType && item.offlinePaymentFlagType !== OFFLINE_PAYMENT_FLAG
  )
}

/**
 * 根据配送类型 + 支付标识匹配获取选中数量 checkedCount
 * @param {Array} dataList - 数据源列表
 * @param {number} shipmentType - 配送类型 1-配送 2-自提
 * @param {number|null|undefined} offlinePaymentFlag - 离线支付标识
 * @returns {number} 匹配到的选中数量总和，未匹配到返回 0
 */
export const getMatchedCheckedCount = (dataList = [], shipmentType, offlinePaymentFlag) => {
  // 不为真都转为 0，保持判断一致
  const targetFlag = offlinePaymentFlag || 0
  // 精准匹配：配送类型 + 标准化后的支付标识，并汇总多个门店数量
  return dataList
    .filter(item => {
      const itemFlag = item.offlinePaymentFlag || 0
      return item.preOrderShipmentType === shipmentType && itemFlag === targetFlag
    })
    .reduce((total, item) => total + Number(item.checkedCount || 0), 0)
}

/**
 * 配送方式Tab数据映射工具函数
 * @param {Array} dataList - 源数据dataList
 * @param {Array} baseList - 原始tab列表baseList
 * @param {Array} offlineList - 动态创建离线支付扩展列表
 * @returns {Array} 处理后的响应式Tab列表（新增amount/tips，创建offlineList有效项）
 */
export const buildDeliveryTabList = (dataList = [], baseList = [], offlineList = []) => {
  // 配送方式映射顺序
  const SORT_MAP = {
    1: 1,
    3: 2,
    2: 3,
    4: 4
  }
  // 配送方式映射
  const SHIPMENT_MAP = {
    1: {
      0: 1,
      1: 3
    },
    2: {
      0: 2,
      1: 4
    }
  }
  // 默认 tab，统一初始化 amount = 0
  const tabMap = new Map(baseList.map(t => [t.id, { ...t, amount: 0 }]))
  // 离线 tab，同样初始化 amount = 0
  const offlineMap = new Map(offlineList.map(t => [t.id, { ...t, amount: 0 }]))
  for (const item of dataList) {
    const { preOrderShipmentType, optionalCount, offlinePaymentFlag, offlinePaymentStr = "" } = item || {}
    const normalizedOfflineFlag = offlinePaymentFlag == null ? 0 : offlinePaymentFlag
    const tabId = SHIPMENT_MAP?.[preOrderShipmentType]?.[normalizedOfflineFlag]
    if (!tabId) continue
    // 无效数量数据
    const isInvalidAmount = optionalCount == null || optionalCount <= 0
    if (normalizedOfflineFlag === 1 && isInvalidAmount) {
      continue
    }
    // 是否创建offlineMap
    if (!tabMap.has(tabId)) {
      const offlineTab = offlineMap.get(tabId)
      if (!offlineTab) continue
      tabMap.set(tabId, offlineTab)
    }
    // 更新属性
    tabMap.set(tabId, {
      ...tabMap.get(tabId),
      amount: Number(tabMap.get(tabId).amount || 0) + Number(optionalCount || 0),
      tips: offlinePaymentStr,
      offlinePaymentFlag: normalizedOfflineFlag
    })
  }
  return [...tabMap.values()].sort((a, b) => SORT_MAP[a.id] - SORT_MAP[b.id])
}

// bestOffer中会有重复的sku
// 根据sku去重
export const getUniqWares = items => {
  const allWares = []
  items.forEach(item => {
    item.wareList.forEach(subItem => {
      allWares.push({
        sku: subItem.skuId,
        skuId: subItem.skuId,
        count: subItem.count,
        stock: subItem.remainingStock
      })
    })
  })

  const tempObj = {}
  allWares.forEach(item => {
    const skuId = item.skuId
    if (!(skuId in tempObj)) {
      tempObj[skuId] = item
    } else {
      tempObj[skuId].count += item.count
    }
  })

  return Object.values(tempObj)
}
